import { render, staticRenderFns } from "./TaskPerformanceRegionReportComponent.vue?vue&type=template&id=d1baf8cc&scoped=true"
import script from "./TaskPerformanceRegionReportComponent.vue?vue&type=script&lang=js"
export * from "./TaskPerformanceRegionReportComponent.vue?vue&type=script&lang=js"
import style0 from "./TaskPerformanceRegionReportComponent.vue?vue&type=style&index=0&id=d1baf8cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1baf8cc",
  null
  
)

export default component.exports